import './evite/log';
import './evite/detects';
import './evite/features';
import './evite/experiments';
import './evite/dom';
import './evite/when';
import './evite/history';
import {Emitter} from './emitter';
/**
 * @note imports happen at the end of the file, so async functions
 * in this file must take precautions caused from hoisting.
 **/
// TODO - Remove once homepage branch merged in (shift to command pattern)
window.regeneratorRuntime = require("regenerator-runtime");

const root =
  typeof window !== 'undefined'? window:
  typeof global !== 'undefined'? global:
  {};

const evite = root.evite || {};
evite.global = root;

let globalIdDefaultPrefix = Math.floor(Math.random() * 2147483647).toString(36);
let globalIdIndex = 0;

export function noop() {
}

// TODO - Delete in favor uuid
export function guid(opt_prefix = 'guid') {
  return `${opt_prefix}-${globalIdDefaultPrefix}-${globalIdIndex++}`
}

export function scope(fn) {
  fn();
}

export function listenTo(subject, type, callback, opt_context) {
  if (opt_context) {
    callback = callback.bind(opt_context);
  }

  const onMethodName = `on${type}`;
  if (typeof subject.addEventListener === 'function') {
    subject.addEventListener(type, callback, false)
  }
  else if (typeof subject.attachEvent === 'function') {
    subject.attachEvent(onMethodName, onReadyStateChange);
  }
  if (typeof subject.on === 'function') {
    subject.on(type, callback);
  }
  else if (onMethodName in subject) {
    if (subject[onMethodName]) {
      subject[onMethodName] = function (originalHandler, ...args) {
        originalHandler.apply(this, args);
        return handler.apply(this, args);
      }.bind(subject, subject[onMethodName])
    }
  }
}

// TODO - delete
function buildNodeList(nodeList, node) {
    if (node.nodeType !== Node.TEXT_NODE) nodeList.push(node);
    if (node.childNodes && node.childNodes.length) {
       Array.from(node.childNodes).reduce(buildNodeList, nodeList);
    }
    return nodeList;
}

// TODO - delete
function bindEvents(eventType, nodeList, callback) {
   [...nodeList].map((node) => {
     node.addEventListener(eventType, callback, true)
   });
}

// TODO - delete
function unbindEvents(eventType, nodeList, callback) {
   [...nodeList].map((node) => {
     node.removeEventListener(eventType, callback, true)
   });
}

// TODO - delete
// NOTE: This bind function does not rely on event bubbling, e.preventDefault() will only
// prevent the default behavior for the Event that you are listening for, not anything above
// or below it in the event stack. Use event.stopImmediatePropagation() or think twice about
// binding events to elements contained within elements with event listeners or default behavior.
export function mutationBind(rootNode, eventType, childQuerySelector, callback) {
  if (!rootNode) return;
  let matchedElements = new Set(Array.from(rootNode.querySelectorAll(childQuerySelector)));
  bindEvents(eventType, matchedElements, callback);
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) {
        Array.from(mutation.addedNodes).forEach((parentNode) => {
          if (parentNode.nodeType === Node.TEXT_NODE || parentNode.nodeType === Node.COMMENT_NODE) return;
          if (parentNode.hasChildNodes()) {
            matchedElements = new Set([...matchedElements, ...parentNode.querySelectorAll(childQuerySelector)]);
          }
          if (parentNode.matches(childQuerySelector)) {
            matchedElements = new Set([...matchedElements, parentNode]);
          }
          bindEvents(eventType, matchedElements, callback)

        });
        return
      }
      if (mutation.removedNodes.length > 0) {
        Array.from(mutation.removedNodes).forEach((parentNode) => {
          if (parentNode.nodeType === Node.TEXT_NODE || parentNode.nodeType === Node.COMMENT_NODE) return;
          if (parentNode.hasChildNodes()) {
            matchedElements = new Set([...matchedElements, ...parentNode.querySelectorAll(childQuerySelector)]);
          }
          if (parentNode.matches(childQuerySelector)) {
            matchedElements = new Set([...matchedElements, parentNode]);
          }
          unbindEvents(eventType, matchedElements, callback)
        })
      }
    });
  });
  observer.observe(rootNode, {subtree: true, childList: true})
}

function liveBindException(arg, value, valid) {
  this.message = 'liveBindException: ';
  this.name = 'liveBindException';
  if (arg) {
      this.message += `liveBind argument "${arg}" missing or invalid`;
  }
  if (value) {
      this.message += ` –– "${value}" supplied`
  }
  if (valid) {
     this. message += `, should be "${valid}"`
  }
}
/**
 * Execute a function and handle exceptions. This function should never throw an exception.
 *
 * @param rootNode: a document node
 * @param eventType: a string that describes the event being bound
 * @param childQuerySelector: a query selector string '#selectorId, .selectorClass'
 * @param callback: function to call when the event is triggered -
 *                  if callback's "thisArg" is not bound, passes event target as first param.
 */
export function liveBind(rootNode, eventType, childQuerySelector, callback) {
  if (!rootNode) {
    // if node is not on the page, do not go any further.
    return;
  }
  try {
    if (!evite.dom.isDomNode(rootNode)) {
      throw new liveBindException('rootNode', rootNode, 'Node')
    } else if (!eventType || typeof eventType !== 'string') {
      throw new liveBindException('eventType', eventType, 'string')
    } else if (!childQuerySelector || typeof childQuerySelector !== 'string') {
      throw new liveBindException('childQuerySelector', childQuerySelector, 'string')
    } else if (!callback || typeof callback !== 'function') {
      throw new liveBindException('callback', callback, 'function')
    }
    rootNode.addEventListener(eventType, (e) => {
      if (e.target.matches(childQuerySelector)) {
        callback.call(e.target, e, ...arguments)
      }
    }, true)
  } catch(exception) {
    if (process.env.NODE_ENV === 'develop') {
      throw exception;
    } else if (console && console.warn) {
      evite.warn(`${exception.name}: ${exception.message}`);
    }
  }
}

export function stopListening(subject, type, callback) {
  const onMethodName = `on${type}`;
  if (typeof subject.removeEventListener === 'function') {
    subject.removeEventListener(type, callback, false)
  }
  else if (typeof subject.detachEvent === 'function') {
    subject.detachEvent(onMethodName, onReadyStateChange);
  }
  if (typeof subject.off === 'function') {
    subject.off(type, callback);
  }
  else if (onMethodName in subject) {
    if (subject[onMethodName]) {
      subject[onMethodName] = null;
    }
  }
}

export const fetch = (function(){
  return async function fetch(url, opt_data = {}) {
    const fetch = await evite.when('fetch');
    evite.info(`fetch: ${url}`);

    const response = await fetch(url, opt_data);
    evite.resolve(url, response);
    return response;
  }
})();

function requestIdleCallbackFallBack(callback) {
  return setTimeout(function () {
    var start = Date.now();
    callback({
      didTimeout: false,
      timeRemaining: function () {
        return Math.max(0, 50 - (Date.now() - start));
      }
    });
  }, 1);
}

export function requestIdleCallback(callback) {
  if (evite.global.requestIdleCallback) {
    return evite.global.requestIdleCallback(callback);
  }

  return requestIdleCallbackFallBack(callback);
}

export function sleep(time) {
  return new Promise(function(resolve){
    setTimeout(resolve, time);
  });
}


export function map(arrOrNum, fn){
  const arr = Array.isArray(arrOrNum)? arrOrNum: new Array(arrOrNum);
  let i = 0;
  let length = arr.length;

  const values = [];
  for(let i = 0; i < length; ++i){
    values.push(fn(arr[i], i, arr));
  }
  return values;
}

// TODO - move out of this file
export function lazyLoadImage({ el, loadWhen, src, priority }) {
  return new Promise(function (resolve, reject) {
    el.classList.add('lazy-loader-initialize');
    var readyToBeginLoading = loadWhen? evite.when(loadWhen): Promise.resolve();
    readyToBeginLoading.then(function () {
      el.classList.remove('lazy-loader-initialize');
      el.classList.add('lazy-loader-loading');

      let loadingAnimationContainerList = el.parentElement.getElementsByClassName('loading-animation-container');
      let loadingAnimationContainer = loadingAnimationContainerList && loadingAnimationContainerList.length && loadingAnimationContainerList[0];
      let loadingStatus = loadingAnimationContainer && (loadingAnimationContainer.querySelector('.loading-animation-status') || loadingAnimationContainer.querySelector('.loading-animation-spinner'));

      if (loadingAnimationContainer) {
        loadingAnimationContainer.classList.remove('hidden');
      }

      if (loadingStatus) {
        loadingStatus.classList.add('loading-animation-status');
        loadingStatus.classList.add('loading-animation-spinner');
      }

      preloadImage(src, priority || 0)
        .then(function () {
          if (loadingAnimationContainer) {
            loadingAnimationContainer.classList.add('hidden');
          }

          el.classList.remove('lazy-loader-loading');
          el.classList.add('lazy-loader-complete');
          el.src = src;
          el.classList.remove('hidden');

          resolve(el);
        })
        .catch(function (message) {
          if (loadingStatus) {
            loadingStatus.classList.remove('loading-animation-spinner');
            loadingStatus.classList.add('loading-animation-error');
            loadingStatus.classList.add('icon-attention-alt');
          }
          if (loadingAnimationContainer) {
            loadingAnimationContainer.title = 'An error occurred downloading the image.' + (el.title? '\n' + el.title: '');
            loadingAnimationContainer.classList.remove('hidden');
          }

          reject(message);
        })
    });
  });
}

const hasOwnProperty = Object.prototype.hasOwnProperty;

export function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

export const observerState = {
  shouldConvert: true,
  isSettingProps: false
};

const OBJECT_STRING = '[object Object]';
export function isPlainObject (obj) {
  return toString.call(obj) === OBJECT_STRING
}

export function observe(o, fn) {
    return new Proxy(o, {
        set: function(target, property, value) {
            target[property] = value;
            fn(property, value);
            return true
        },
        get: function(target, property, value) {
            if (property in target) {
                return target[property];
            }
        }
    })
}

const imageQueue = [];
function preloadImage(src, priority) {
  for(var i = 0; i <= priority; ++i) {
    imageQueue[priority] = imageQueue[priority] || [];
  }


  return new Promise(function (resolve, reject) {
    var image = new Image();
    listenTo(image, 'load', function(){
      evite.resolve(src, image).then(resolve);
    });
    listenTo(image, 'error', function (event) {
      reject(`Image failed to load: src="${src}"'`);
    });
    image.src = src;

  });
}

export function toJSON(value){
  if (!value || typeof value !== 'object') {
    return value;
  }

  if(typeof value === 'function' || value instanceof Function){
    return null;
  }

  if ('toJSON' in value) {
    value = value.toJSON();
  }

  if (Array.isArray(value)) {
    return value.map(toJSON);
  }

  const attributes = {};
  for(let key in value) {
    attributes[key] = toJSON(value[key]);
  }
  return attributes;
}

evite.when('evite').then(function(evite){
  function onReadyStateChange() {
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
      evite.resolve('document.ready', document);
    }

    if (document.readyState === 'complete') {
      evite.resolve('window.load', window);
    }
  }

  evite.listenTo(document, 'readystatechange', onReadyStateChange);
  evite.listenTo(document, 'DOMContentLoaded', onReadyStateChange);
  evite.listenTo(document, 'load', onReadyStateChange);

  onReadyStateChange();
});


evite.when('document.ready').then(function(){
  window.requestAnimationFrame && window.requestAnimationFrame(function(){
    requestAnimationFrame(function(){
      evite.resolve('page.render');
    })
  })
});

/**
 * Execute a function and handle exceptions. This function should never throw an exception.
 *
 * @param func
 */
export function logAndContinue(func) {
  if(!func)
    return;

  try {
    func()
  }
  catch(e) {
    logError(e);
  }
}


/**
 * Execute a function and handle exceptions. This function should never throw an exception.
 *
 * @param {string|Error}error
 */
export function logError(error) {
  if (error) {
    if (window.Raven) {
      Raven.captureException(error);
    }

    evite.error('Caught exception: ' + error);
    evite.trace(error);
  }
}


evite.Emitter = Emitter;
evite.global.require = function (name) {
  return root[name];
};

evite.global.evite = Object.assign(evite, exports);
evite.resolve('evite', evite);

export default evite;



// WEBPACK FOOTER //
// ./assets/es6/common/evite.es6